import { IonButton, IonIcon } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

export const MyBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const getButton = useCallback(() => {
    if (location?.pathname !== '/') {
      return (
        <IonButton onClick={goBack} data-testid="back-button">
          <IonIcon slot="icon-only" icon={arrowBack} />
        </IonButton>
      );
    }

    return null;
  }, [goBack, location?.pathname]);

  return getButton();
};
